// N20-4 — THE SITE IDENTITY, IN ONE PLACE.
//
// THE OWNER'S RULING (2026-07-28): the tagline is **"Metaphysical Intelligence"**. It used to be
// "Spiritual Intelligence" and it rendered in more than one file, which is how a tagline ends up
// being two different things on two different screens. Per the consolidation law it is ONE CONSTANT
// now, and everything that says it imports it from here.
//
// `index.html` is static and cannot import, so it carries the same strings inline; the fast gate
// checks the two against each other, so they cannot drift apart in silence.
export const SITE_NAME = "12th House";
export const SITE_TAGLINE = "Metaphysical Intelligence";
export const SITE_DOMAIN = "12thhouse.ai";
export const SITE_URL = `https://${SITE_DOMAIN}`;

// The one-line link-preview description. Her ruling names the tagline as the line that sits under
// the logo on every preview card, so that is exactly what this is. No em dashes.
export const SITE_DESCRIPTION = SITE_TAGLINE;

// The longer meta description for search results, which is a different job from a preview card.
export const SITE_META_DESCRIPTION =
  "Astrology, numerology, tarot, Human Design, dreams and daily guidance, read for you in your own words.";

export const OG_IMAGE = "/og-card.png";
